import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import DJMixerPro from "@/pages/DJMixerPro";
import LibraryManager from "@/pages/LibraryManager";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AdminPanel from "@/pages/AdminPanel";
import MetadataEditor from "@/pages/MetadataEditor";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Global axios interceptor — strips null/undefined Bearer tokens before every request
axios.interceptors.request.use((config) => {
  const auth = config.headers?.Authorization;
  if (auth && (auth === 'Bearer null' || auth === 'Bearer undefined' || auth === 'Bearer ')) {
    delete config.headers.Authorization;
  }
  return config;
});

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/mixer" element={<DJMixerPro />} />
          <Route path="/library" element={<LibraryManager />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/metadata" element={<MetadataEditor />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
